import { render, staticRenderFns } from "./connections.vue?vue&type=template&id=2362b7f2&scoped=true&"
import script from "./connections.vue?vue&type=script&lang=js&"
export * from "./connections.vue?vue&type=script&lang=js&"
import style0 from "./connections.vue?vue&type=style&index=0&id=2362b7f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2362b7f2",
  null
  
)

export default component.exports